import * as core from '../../../../../../../core'

import { query } from './save-proposal.query'

export const RESOURCE = {
  payload: {
    alias: 'save.proposal',
    description: 'Creates or updates a proposal from the proposal modal',
    name: 'Save Proposal',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
